// extracted by mini-css-extract-plugin
module.exports = {"clickOutside":"_3sSttGGYMdDiEr_8RvgQGx","block":"_1o6cespAy1XIlTwLTEhgb0"};